@use 'sass:map';
@use 'sass:math';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@import '@helsenorge/designsystem-react/scss/breakpoints';

// Credit: Nicolas Gallagher and SUIT CSS.

.videospiller {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
  background-color: palette.$black;

  &::before {
    display: block;
    content: '';
  }

  &__iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }

  &--16by9 {
    &::before {
      padding-top: math.percentage(0.5625);
    }
  }

  &--visualInterpretation {
    order: -1;
    margin-bottom: spacers.getSpacer('l');
    width: 100%;
  }

  @media print {
    display: none;
  }
}

.videobeskrivelse {
  padding-bottom: spacers.getSpacer(s);

  &__title {
    font-size: 1.4rem;
    margin-top: spacers.getSpacer(2xs);
    margin-bottom: 0;
  }

  &__description {
    margin-top: spacers.getSpacer(3xs);
    margin-bottom: 0;
  }
}

// Custom breakpoint for terms of service
$between-xs-and-s: 414px;

.tos-overlay {
  z-index: 1;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: spacers.getSpacer(2xs);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  @media (min-width: map.get($grid-breakpoints, lg)) {
    padding: spacers.getSpacer(s);
  }

  &__title {
    color: palette.$white;
  }
}

.tos {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: spacers.getSpacer(4xs) spacers.getSpacer(2xs) spacers.getSpacer(2xs);
  width: 280px;
  background-color: palette.$white;
  max-width: 98%;
  max-height: 98%;
  overflow-y: auto;

  @media (max-width: map.get($grid-breakpoints, xs)) {
    font-size: 16px;
    line-height: 22px;
  }

  @media (min-width: map.get($grid-breakpoints, xs)) {
    width: 305px;
    padding: spacers.getSpacer(2xs) spacers.getSpacer(s);
  }

  @media (min-width: $between-xs-and-s) {
    width: 317px;
    padding: spacers.getSpacer(2xs) spacers.getSpacer(m);
  }

  @media (min-width: map.get($grid-breakpoints, md)) {
    width: 467px;
    padding: spacers.getSpacer(l) spacers.getSpacer(s);
  }

  @media (min-width: map.get($grid-breakpoints, lg)) {
    width: 531px;
    padding: spacers.getSpacer(xl);
  }

  &__text {
    margin-bottom: spacers.getSpacer(2xs);

    @media (min-width: map.get($grid-breakpoints, xs)) {
      margin-bottom: spacers.getSpacer(2xs);
    }

    @media (min-width: $between-xs-and-s) {
      margin-bottom: spacers.getSpacer(s);
    }

    @media (min-width: map.get($grid-breakpoints, md)) {
      margin-bottom: spacers.getSpacer(m);
    }
  }

  &__remember {
    margin-bottom: spacers.getSpacer(2xs);

    @media (min-width: $between-xs-and-s) {
      margin-bottom: spacers.getSpacer(s);
    }
  }
}
